module.exports = __webpack_public_path__ + "f98e896c7b811acf930922ed6b6a130d.svg";